export const validateEmail = (email: string | undefined) => {
  if (!email) return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Check if the email matches the regex pattern
  if (!emailRegex.test(email)) {
    return false; // Doesn't match the basic email format
  }

  // Additional checks for domain name presence and special characters
  const atIndex = email.indexOf('@');
  const dotIndex = email.lastIndexOf('.');
  const domain = email.slice(dotIndex + 1);

  if (
    atIndex === -1 ||
    dotIndex === -1 ||
    atIndex > dotIndex ||
    domain.length < 2
  ) {
    return false; // No @ symbol, no dot, or invalid domain
  }

  const specialCharactersRegex = /[^\w.@-]/;
  if (specialCharactersRegex.test(email)) {
    return false; // Contains special characters other than @, ., _, and -
  }

  return true; // Passed all che
};
